import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

export function initSentry(): void {
    if (!dsn || import.meta.env.DEV) return;

    Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
        tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) || 0.1,
        integrations: [Sentry.browserTracingIntegration()],
        beforeSend(event, hint) {
            const error = hint?.originalException;
            if (error && typeof error === 'object' && 'graphQLErrors' in error) {
                const gqlErrors = (error as { graphQLErrors: Array<{ extensions?: { code?: string } }> }).graphQLErrors;
                if (
                    Array.isArray(gqlErrors) &&
                    gqlErrors.length > 0 &&
                    gqlErrors.every(
                        (e) => e.extensions?.code === 'UNAUTHORIZED' || e.extensions?.code === 'FORBIDDEN'
                    )
                ) {
                    return null;
                }
            }
            return event;
        },
    });
}

export { Sentry };
